import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import type { AllowedIpPrefixDto } from "client/api/CloudSubscriptionApi";
import { deleteCloudSubscriptionAllowedIpAddress } from "client/api/CloudSubscriptionApi";
import { SubmittableForm } from "components/form/SubmittableForm";

type CloudSubscriptionDeleteAllowedIpAddressDialogProps = {
  cloudSubscriptionId: string;
  allowListActive: boolean;
  hasSingleAllowedIp: boolean;
  allowedIp: AllowedIpPrefixDto;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  open: boolean;
};

export function CloudSubscriptionDeleteAllowedIpAddressDialog(
  props: CloudSubscriptionDeleteAllowedIpAddressDialogProps
) {
  const { cloudSubscriptionId, allowListActive, hasSingleAllowedIp, allowedIp, onClose, onConfirm, open } = props;

  const handleSubmit = async () => {
    await deleteCloudSubscriptionAllowedIpAddress(cloudSubscriptionId, allowedIp.prefix);
    await onConfirm();
  };

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>
        Delete IP address or range
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} rowSpacing={2}>
          <Grid size={12}>
            <SubmittableForm submitLabel="Delete" submitColor="error" submitAction={handleSubmit} onCancel={onClose}>
              {() => {
                return (
                  <>
                    <Grid size={12}>
                      <Typography
                        sx={{
                          marginBottom: "16px",
                        }}
                      >
                        Delete {allowedIp.prefix} {allowedIp.description ? `"${allowedIp.description}"` : ""} from the
                        allow list?
                        <br />
                        This IP address or range will no longer have access when IP address allow listing is activated.
                      </Typography>
                      {allowListActive && (
                        <>
                          {hasSingleAllowedIp && (
                            <Typography
                              sx={{
                                marginBottom: "16px",
                              }}
                            >
                              Activating IP address allow list with no list entries will result in the customer{" "}
                              <strong>only</strong> being able to access this instance via Azure Private Link.
                            </Typography>
                          )}
                          <Typography
                            sx={{
                              marginBottom: "16px",
                            }}
                          >
                            Changes to IP address allow lists can take up to 60 seconds to take effect.
                          </Typography>
                        </>
                      )}
                    </Grid>
                  </>
                );
              }}
            </SubmittableForm>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
